// extracted by mini-css-extract-plugin
var _1 = "styles_brand__X-ETn";
var _2 = "styles_container__T1EgS";
var _3 = "styles_details__bzUjX";
var _4 = "styles_disabled__meQ2V";
var _5 = "styles_name__+Jfcd";
var _6 = "styles_ratingContainer__dDPkK";
export { _1 as "brand", _2 as "container", _3 as "details", _4 as "disabled", _5 as "name", _6 as "ratingContainer" }
